var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfPlayerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#F56708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.009 1.383c-.362 0-3.122.12-5.956.257A2.182 2.182 0 0 0 9.843.003a2.191 2.191 0 0 0-2.04 1.85l-1.519.076a1.3 1.3 0 0 0-1.019-.559 1.24 1.24 0 0 0-1.214 1.242c-.17 1.33.056 2.86 1.149 3.791.975.834 2.255 1.011 3.483.923.666 1.876.784 3.88 1.406 5.765a93.63 93.63 0 0 0-1.65 9.313c-.27 2.141 3.048 2.115 3.296 0a79.77 79.77 0 0 1 .927-5.641 22.866 22.866 0 0 0 3.144 6.08c1.253 1.711 4.118.044 2.843-1.694a21.546 21.546 0 0 1-3.54-7.801 2.13 2.13 0 0 0 0-1.33c-.718-1.97-.805-4.085-1.51-6.058a2.667 2.667 0 0 0-2.526-1.92 2.226 2.226 0 0 0 1.04-1.872l5.12-.057c-.574 2.66 2.717 2.824 2.765 2.15.057-.847-1.215-2.86-1.99-2.878zM9.332 4.83h-.096c-.832.11-1.772.204-2.477-.257-.462-.302-.4-1.33-.318-1.982a.903.903 0 0 0-.04-.386h1.376c.02 1.2.973 2.167 2.151 2.182a2.74 2.74 0 0 0-.596.443z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfPlayerIcon);
export default __webpack_public_path__ + "static/media/golf-player-icon.e812bae83d90c917e47bf771060e5f51.svg";
export { ForwardRef as ReactComponent };